import React, { useState, useEffect } from 'react'
import Geocode from 'react-geocode'
import { getLocalstoreData, getSessionstoreData } from '../Store/GetData'
import { Link as GatsbyLink } from 'gatsby'
import { toast } from 'react-toastify'
import isObject from 'lodash/isObject'
import { DeleteSessionstore } from '../Store/DeleteData'
import { components } from 'react-select'
import { verifyReferal } from './services'
import { Sessionstore } from '../Store/StoreData'
import { getCalApi } from "@calcom/embed-react";
import {
  buildClickKey,
  campaignTrackRequestKey,
  readPageTrackingId,
  shouldReuseStoredTrackingId,
  TRACKING_CLICK_KEY_STORAGE_KEY,
  TRACKING_ID_STORAGE_KEY,
} from './waGoLanding';
import {
  attributionCookie,
  attributionDecision,
  buildAttributionRecord,
  gclidFromGclAw,
  readStoredAttribution,
  TRACKING_ATTR_KEY,
  UTM_FIELDS,
} from './campaignTrack';


export const getBase64 = file => {
  return new Promise(resolve => {
    let baseURL = ''
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      baseURL = reader.result
      file['base64'] = baseURL
      var Base64 = file.base64.replace('data:image/png;base64,', '')
      resolve(Base64)
    }
  })
}

export const AddressToLatLng = Address => {
  return new Promise((resolve, reject) => {
    Geocode.fromAddress(Address, process.env.GOOGLE_API_KEY)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const toInputUppercase = e => {
  e.target.value = ('' + e.target.value).toUpperCase()
}

export const LatLngToAddress = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(function (position) {
      Geocode.fromLatLng(
        position.coords.latitude,
        position.coords.longitude,
        process.env.GOOGLE_API_KEY
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  })
}



const CAL_EMBED_URL = 'https://bookings.academy.ableaura.com/embed/embed.js';
const CAL_ORIGIN = 'https://bookings.academy.ableaura.com';

const CLICK_ID_PARAM_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];

export const CITY_LANDING_PATHS = ['/chennai', '/bangalore', '/bengaluru'];

export const isCityLandingPath = (pathname) => {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return CITY_LANDING_PATHS.includes(path);
};

/** City pages that already show the sticky Chat now bar. */
export const cityLandingHasStickyBar = (pathname) => {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return path === '/chennai' || path === '/bangalore' || path === '/bengaluru';
};

/**
 * Load the Cal.com embed on demand. Not called at page load.
 * @returns {Promise<object|null>}
 */
let calendarPromise = null;
export const ensureCalendar = () => {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (!calendarPromise) {
    calendarPromise = (async () => {
      const cal = await getCalApi({ embedJsUrl: CAL_EMBED_URL });
      try {
        cal('ui', {
          styles: { branding: { brandColor: '#000000' } },
          hideEventTypeDetails: false,
          layout: 'month_view',
        });
      } catch (error) {
        console.error('Failed to initialize Cal.com calendar:', error);
      }
      window.__ableauraCalReady = true;
      return cal;
    })().catch((error) => {
      calendarPromise = null;
      console.error('Failed to initialize Cal.com calendar:', error);
      throw error;
    });
  }
  return calendarPromise;
};

export const initializeCalendar = () => ensureCalendar();

const AD_CLICK_PARAM_KEYS = [
  'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid',
  'fbclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign',
  'utm_term', 'utm_content', 'utm_id', 'lead_id', 'lead_type',
  'cid', 'gid', 'crid', 'kw', 'net',
];

const URL_CLEANUP_PARAMS = [
  'gclid', 'utm_source', 'utm_medium', 'utm_campaign',
  'utm_term', 'utm_content', 'gad_source', 'gad_campaignid', 'gbraid',
  'wbraid', 'lead_id', 'lead_type', 'fbclid', 'msclkid', 'utm_id',
];

const WHATSAPP_PHONE = '917868880000';
const DEFAULT_WA_MESSAGE_BASE = 'Hello, I have a question about Ableaura Sports Academy';

/** @type {Promise<string|null>|null} */
let trackingInFlight = null;
let trackingInFlightKey = '';

const readWindowAttribution = () => {
  if (typeof window === 'undefined') return null;
  let storage = null;
  try {
    storage = window.localStorage;
  } catch (e) {
    storage = null;
  }
  return readStoredAttribution({
    localStorage: storage,
    cookie: typeof document !== 'undefined' ? document.cookie : '',
  });
};

export const getStoredTrackingId = () => {
  const record = readWindowAttribution();
  return record && record.id ? record.id : null;
};

export const hasAdClickParamsInUrl = () => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return AD_CLICK_PARAM_KEYS.some((key) => {
    const v = params.get(key);
    return v != null && v !== '';
  });
};

export const hasStoredAdParams = () => {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem('adsParams');
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return AD_CLICK_PARAM_KEYS.some((key) => parsed && parsed[key]);
  } catch (e) {
    return false;
  }
};

/** True when this session likely came from paid/UTM ads (URL or stored). */
export const isLikelyPaidLanding = () =>
  hasAdClickParamsInUrl() || hasStoredAdParams();

export const appendRefToMessage = (message, trackingId) => {
  const base = message || '';
  if (!trackingId) return base;
  if (base.includes('Ref:') || base.includes('Tracking ID:')) return base;
  return `${base} (Ref: ${trackingId})`;
};

export const buildDefaultWhatsAppMessage = (trackingId = null) => {
  if (typeof window === 'undefined') {
    return appendRefToMessage(DEFAULT_WA_MESSAGE_BASE, trackingId);
  }
  const isDev = window.location.hostname === 'dev.academy.ableaura.com';
  const base = `${DEFAULT_WA_MESSAGE_BASE}${isDev ? ' (Developer)' : ''}`;
  return appendRefToMessage(base, trackingId || getStoredTrackingId());
};

const getApiBaseUrl = () => {
  let baseUrl = process.env.BaseURL;
  if (!baseUrl && typeof window !== 'undefined') {
    if (window.location.hostname.includes('dev')) {
      baseUrl = 'https://dev.web.api.ableaura.com/api';
    } else {
      baseUrl = 'https://api.web.ableaura.com/api';
    }
  }
  return baseUrl;
};

const collectAdsParams = () => {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const adsParams = {
    gclid: params.get('gclid'),
    gbraid: params.get('gbraid'),
    wbraid: params.get('wbraid'),
    gad_source: params.get('gad_source'),
    gad_campaignid: params.get('gad_campaignid'),
    lead_id: params.get('lead_id'),
    lead_type: params.get('lead_type'),
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_term: params.get('utm_term'),
    utm_content: params.get('utm_content'),
    utm_id: params.get('utm_id'),
    fbclid: params.get('fbclid'),
    msclkid: params.get('msclkid'),
    cid: params.get('cid'),
    gid: params.get('gid'),
    crid: params.get('crid'),
    kw: params.get('kw'),
    net: params.get('net'),
    landing_page: window.location.pathname,
    referrer: document.referrer,
    device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
  };
  const fresh = Object.fromEntries(
    Object.entries(adsParams).filter(([, v]) => v != null && v !== '')
  );
  return mergeCapturedAdsParams(fresh);
};

const hasClickId = (obj) => CLICK_ID_PARAM_KEYS.some((key) => obj && obj[key]);

/**
 * The address bar drops gclid about 2s after a successful track. Later reads
 * must still send the original click ids and utm values. Nothing here invents
 * a medium: utm_medium is copied only when the landing URL had it.
 */
const mergeCapturedAdsParams = (fresh) => {
  if (typeof window === 'undefined') return fresh;
  if (!window.__ableauraAdsSnapshot && hasClickId(fresh)) {
    window.__ableauraAdsSnapshot = { ...fresh };
    window.__ableauraAdsSearch = window.location.search || '';
  }
  const snap = window.__ableauraAdsSnapshot;
  if (!snap || hasClickId(fresh) || !hasClickId(snap)) return fresh;
  const merged = { ...fresh };
  const keep = [
    ...CLICK_ID_PARAM_KEYS,
    'gad_source', 'gad_campaignid', 'lead_id', 'lead_type',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'cid', 'gid', 'crid', 'kw', 'net',
  ];
  keep.forEach((key) => {
    if (snap[key] && !merged[key]) merged[key] = snap[key];
  });
  return merged;
};

const cleanTrackingParamsFromUrl = () => {
  try {
    console.log('[Tracking] Cleaning URL parameters...');
    const url = new URL(window.location.href);
    let paramRemoved = false;
    URL_CLEANUP_PARAMS.forEach((p) => {
      if (url.searchParams.has(p)) {
        url.searchParams.delete(p);
        paramRemoved = true;
      }
    });
    if (paramRemoved) {
      window.history.replaceState({}, '', url.toString());
      console.log('[Tracking] ✅ URL cleaned:', url.toString());
    }
  } catch (e) {
    console.error('[Tracking] ❌ Error cleaning URL params:', e);
  }
};

const getStoredClickKey = () => {
  const record = readWindowAttribution();
  return record && record.clickKey ? record.clickKey : '';
};

const clicksFromPayload = (payload) => ({
  gclid: (payload && payload.gclid) || '',
  gbraid: (payload && payload.gbraid) || '',
  wbraid: (payload && payload.wbraid) || '',
  fbclid: (payload && payload.fbclid) || '',
  msclkid: (payload && payload.msclkid) || '',
  utm_source: (payload && payload.utm_source) || '',
  utm_medium: (payload && payload.utm_medium) || '',
  utm_campaign: (payload && payload.utm_campaign) || '',
  utm_term: (payload && payload.utm_term) || '',
  utm_content: (payload && payload.utm_content) || '',
  utm_id: (payload && payload.utm_id) || '',
});

const publishAttribution = (record, requestKey) => {
  if (!record || !record.id || typeof window === 'undefined') return;
  window.__ableauraWaTrackingId = record.id;
  window.__ableauraWaTrackingReady = true;
  window.__ableauraWaTrackingKey = record.clickKey || '';
  if (typeof requestKey === 'string') {
    window.__ableauraWaTrackingRequestKey = requestKey;
  }
  try {
    window.dispatchEvent(new Event('tracking_id_updated'));
  } catch (e) {
    // The id is already stored. Listeners can read it on the next click.
  }
};

let urlCleanupScheduled = false;
const scheduleUrlCleanup = () => {
  if (urlCleanupScheduled) return;
  urlCleanupScheduled = true;
  setTimeout(cleanTrackingParamsFromUrl, 2000);
};

const storeTrackingId = (trackingId, clickKey, requestKey, clicks) => {
  if (!trackingId || typeof window === 'undefined') return;
  const record = buildAttributionRecord(trackingId, clickKey, clicks);
  try {
    window.localStorage.setItem(TRACKING_ID_STORAGE_KEY, record.id);
    window.localStorage.setItem(TRACKING_CLICK_KEY_STORAGE_KEY, record.clickKey);
    window.localStorage.setItem(TRACKING_ATTR_KEY, JSON.stringify(record));
    console.log('[Tracking] ✅ Tracking ID stored:', record.id);
  } catch (e) {
    console.error('[Tracking] ❌ Failed to store tracking_id', e);
  }
  try {
    document.cookie = attributionCookie(record);
  } catch (e) {
    // Cookie is the fallback when localStorage is blocked.
  }
  publishAttribution(record, requestKey);
};

const storedIdForClick = (clickKey) => {
  const storedId = getStoredTrackingId();
  if (!shouldReuseStoredTrackingId({
    storedId,
    storedKey: getStoredClickKey(),
    clickKey,
  })) {
    return null;
  }
  return storedId;
};

/**
 * POST campaign/track and return tracking_id (or null).
 * Dedupes concurrent calls via trackingInFlight.
 */
export const sendAdsDataToApi = async (validParams) => {
  if (typeof window === 'undefined') return null;

  const payload = validParams && Object.keys(validParams).length
    ? { ...validParams }
    : collectAdsParams();

  let clickKey = buildClickKey(payload);
  const hasUtm = UTM_FIELDS.some((key) => payload[key]);
  const stored = readWindowAttribution();
  const gclAw = !clickKey && !hasUtm && !(stored && stored.id)
    ? gclidFromGclAw(typeof document !== 'undefined' ? document.cookie : '')
    : '';
  const decision = attributionDecision({
    clickKey,
    hasUtm,
    stored,
    gclAwGclid: gclAw,
  });
  const landingPage = payload.landing_page || window.location.pathname || '';

  // Later pages with no new click id reuse the stored row. They must not POST.
  if (decision.action === 'reuse') {
    const requestKey = campaignTrackRequestKey(stored.clickKey || '', landingPage);
    if (!stored.exp) {
      const parts = String(stored.clickKey || '').split('\n');
      storeTrackingId(stored.id, stored.clickKey, requestKey, {
        gclid: stored.gclid || parts[0] || '',
        gbraid: stored.gbraid || parts[1] || '',
        wbraid: stored.wbraid || parts[2] || '',
        fbclid: stored.fbclid || parts[3] || '',
        msclkid: stored.msclkid || parts[4] || '',
      });
    } else {
      publishAttribution(stored, requestKey);
    }
    return stored.id;
  }
  if (decision.action === 'skip') return null;

  if (decision.gclid && !payload.gclid) {
    payload.gclid = decision.gclid;
    clickKey = buildClickKey(payload);
  }

  const requestKey = campaignTrackRequestKey(clickKey, landingPage);

  // The landing script may already have started this POST. Join it
  // instead of inserting a second campaign_trackings row.
  const shared = window.__ableauraCampaignTrack;
  if (shared && shared.key === requestKey && shared.promise) {
    const sharedId = await shared.promise;
    if (sharedId) {
      storeTrackingId(sharedId, clickKey, requestKey, clicksFromPayload(payload));
      scheduleUrlCleanup();
      return sharedId;
    }
  }

  if (trackingInFlight && trackingInFlightKey === requestKey) {
    return trackingInFlight;
  }

  const run = (async () => {
    try {
      try {
        localStorage.setItem('adsParams', JSON.stringify(payload));
      } catch (e) { /* ignore */ }

      const baseUrl = getApiBaseUrl();
      const apiUrl = `${baseUrl}/campaign/track`;
      console.log('[Tracking] Sending to API...', apiUrl, payload);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      });

      if (!response.ok) {
        console.error('[Tracking] ❌ API response not OK:', response.status);
        return storedIdForClick(clickKey);
      }

      const data = await response.json();
      if (data && data.tracking_id) {
        storeTrackingId(data.tracking_id, clickKey, requestKey, clicksFromPayload(payload));
        // Clean URL only after successful track (keep gclid for GTM first ~2s)
        scheduleUrlCleanup();
        return data.tracking_id;
      }

      console.warn('[Tracking] ⚠️ No tracking_id in response', data);
      // Do not attach a previous visit's ref to a different ad click.
      return storedIdForClick(clickKey);
    } catch (error) {
      console.error('[Tracking] ❌ Background tracking error:', error);
      return storedIdForClick(clickKey);
    } finally {
      if (trackingInFlight === run) {
        trackingInFlight = null;
      }
    }
  })();

  trackingInFlight = run;
  trackingInFlightKey = requestKey;
  window.__ableauraCampaignTrack = { key: requestKey, promise: run };
  return run;
};

/**
 * Ensure we have a tracking_id before opening WhatsApp.
 * For paid landings, waits up to timeoutMs for /campaign/track.
 */
export const ensureTrackingId = async (timeoutMs = 2500) => {
  if (typeof window === 'undefined') return null;

  const params = collectAdsParams();
  const clickKey = buildClickKey(params);
  const existing = getStoredTrackingId();
  // A new gclid/gbraid/wbraid/fbclid/msclkid must not reuse an older Ref.
  if (shouldReuseStoredTrackingId({
    storedId: existing,
    storedKey: getStoredClickKey(),
    clickKey,
  })) {
    return existing;
  }

  // landing_page / referrer / device_type are always set, so an empty check
  // on every key made organic clicks wait out the full timeout.
  if (!AD_CLICK_PARAM_KEYS.some((key) => params[key])) {
    return storedIdForClick(clickKey);
  }

  const started = Date.now();
  const promise = sendAdsDataToApi(params);

  while (Date.now() - started < timeoutMs) {
    const id = getStoredTrackingId();
    const key = getStoredClickKey();
    if (shouldReuseStoredTrackingId({ storedId: id, storedKey: key, clickKey })) {
      return id;
    }
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, 50));
  }

  const finalId = await promise;
  if (finalId) return finalId;
  // This click was not saved. Do not put the previous visit's Ref on it.
  if (clickKey) return null;
  return getStoredTrackingId();
};

export const getAttributableTrackingId = () => {
  if (typeof window === 'undefined') return null;
  const id = readPageTrackingId();
  return id || null;
};

/**
 * Open WhatsApp without waiting on /campaign/track. A delayed window.open is
 * dropped by iOS Safari and in-app browsers. Prefer a real <a data-wa-direct>.
 */
export const openWhatsAppWithTracking = (options = {}) => {
  if (typeof window === 'undefined') return;

  const {
    phone = WHATSAPP_PHONE,
    messageBase = null,
    source = 'unknown',
  } = options;

  window.dataLayer = window.dataLayer || [];

  const trackingId = getAttributableTrackingId();
  const message = messageBase
    ? appendRefToMessage(messageBase, trackingId)
    : buildDefaultWhatsAppMessage(trackingId);

  window.dataLayer.push({
    event: 'whatsapp_click',
    source,
    page: window.location.pathname,
    has_tracking_id: Boolean(trackingId),
    tracking_id: trackingId || null,
  });

  const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
  window.location.assign(url);
};

const buildCalMetadata = () => {
  const params = typeof window === 'undefined' ? {} : collectAdsParams();
  const trackingId = getAttributableTrackingId();
  const metadata = {};
  if (trackingId) metadata.ref = String(trackingId);
  ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
    if (params[key]) metadata[key] = String(params[key]);
  });
  return metadata;
};

export const buildCalendarButtonProps = (location) => {
  const metadata = typeof window === 'undefined' ? {} : buildCalMetadata();
  return {
    'data-cal-link': `team/${location}/30-mins-meeting`,
    'data-cal-origin': CAL_ORIGIN,
    'data-cal-config': JSON.stringify({ layout: 'month_view', metadata }),
  };
};

export const openCalendarModal = async (location) => {
  const cal = await ensureCalendar();
  if (!cal) return;
  const metadata = buildCalMetadata();
  cal('modal', {
    calLink: `team/${location}/30-mins-meeting`,
    calOrigin: CAL_ORIGIN,
    config: { layout: 'month_view', metadata },
  });
};

export const captureAndSendAdsData = () => {
  if (typeof window === 'undefined') return;

  // /campaign-track.js owns the request on full page loads. Client-side
  // route changes call it again; it reuses a stored id instead of posting.
  if (typeof window.__ableauraRunCampaignTrack === 'function') {
    window.__ableauraRunCampaignTrack();
    return;
  }

  sendAdsDataToApi();
};


/**
 * Returns props for Cal.com calendar buttons
 * @returns {Object} Button props
 */
export const getCalendarButtonProps = (location) => buildCalendarButtonProps(location);


// export const SummerCampWhatsapp = () => {
//   const handleWhatsAppClick = (e) => {
//     e.preventDefault();
//     const url = `https://api.whatsapp.com/send/?phone=917868880000&text=I+want+to+enquire+about+summer+camp+2025&type=phone_number&app_absent=0&utm_source=newsletter&utm_medium=email&utm_campaign=monthly_newsletter`;
//     window.open(url, '_blank');
//   };

//   const buttonStyle = {
//     position: "fixed",
//     width: "60px",
//     height: "60px",
//     bottom: "40px",
//     right: "40px",
//     backgroundColor: "#25d366",
//     color: "#FFF",
//     borderRadius: "50px",
//     textAlign: "center",
//     fontSize: "30px",
//     boxShadow: "2px 2px 3px #999",
//     zIndex: "100",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     cursor: "pointer",
//     '@media (max-width: 768px)': {
//       width: "50px",
//       height: "50px",
//       bottom: "20px",
//       right: "20px",
//       fontSize: "25px",
//     }
//   };

//   return (
//     <div
//       onClick={handleWhatsAppClick}
//       style={buttonStyle}
//       className="summer-camp-whatsapp"
//     >
//       <i className="fab fa-whatsapp" style={{ marginTop: "0px" }}></i>
//     </div>
//   );
// };





// const pageMapping = {
//   // Bengaluru
//   '/bengaluru': 'bengaluru',
//   '/bangalore': 'bengaluru',
//   '/bengaluru-academy': 'bengaluru',
//   '/bangalore-academy': 'bengaluru',
//   '/location/bengaluru': 'bengaluru',
//   '/location/bangalore': 'bengaluru',
//   '/bg': 'bengaluru',

//   // Chennai
//   '/chennai': 'chennai',
//   '/chennai-academy': 'chennai',
//   '/location/chennai': 'chennai',
// };

// const locationMapping = {
//   ablectn01: 'chennai',
//   ablekba02: 'bengaluru',
// };



// const normalisePath = raw =>
//   raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(/\/+$/, '')
//     .toLowerCase();


// export const getCurrentLocation = rawPathname => {
//   const pathname = normalisePath(rawPathname);
//   const fromPage = pageMapping[pathname];

//   if (fromPage) return fromPage;

//   let popupCode = localStorage.getItem('lxct');
//   if (popupCode) {
//     try { popupCode = JSON.parse(popupCode); } catch (_) { }
//     if (locationMapping[popupCode]) return locationMapping[popupCode];
//   }

//   return 'chennai';
// };

// export const getWidgetConfig = pathname => {
//   const loc = getCurrentLocation(pathname);


//   const messageMapping = {
//     'chennai': 'Hello, %0AI have a question about Ableaura Sports Academy',
//     'bengaluru': 'Hello, %0AI have a question about Ableaura Sports Academy in Bengaluru',
//   };

//   const message = messageMapping[loc] || 'Hello, %0AI have a question about Ableaura Sports Academy in Chennai';

//   return {
//     id: `${loc}-widget`,
//     scriptUrl:
//       'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?44554',
//     options: {
//       enabled: true,
//       chatButtonSetting: {
//         backgroundColor: '#00e785',
//         ctaText: 'Chat with us',
//         borderRadius: '25',
//         marginLeft: '0',
//         marginRight: '20',
//         marginBottom: '20',
//         ctaIconWATI: false,
//         position: 'right',
//       },
//       brandSetting: {
//         brandName: 'Ableaura Academy',
//         brandSubTitle: 'undefined',
//         brandImg: 'https://www.wati.io/wp-content/uploads/2023/04/Wati-logo.svg',
//         welcomeText: 'Hi there!\nHow can I help you?',
//         messageText: message,
//         backgroundColor: '#00e785',
//         ctaText: 'Chat with us',
//         borderRadius: '25',
//         autoShow: false,
//         phoneNumber: '917868880000',
//       },
//     },
//   };
// };




// export class WatiWidgetManager {
//   static currentScript = null;
//   static currentWidgetId = null;


//   static removeCurrentWidget() {
//     try {

//       document
//         .querySelectorAll('script[src*="watiWidget.js"]')
//         .forEach(n => n.parentNode?.removeChild(n));

//       if (this.currentScript?.parentNode) {
//         this.currentScript.parentNode.removeChild(this.currentScript);
//       }

  
//       [
//         '[id*="wati-widget"]',
//         '[class*="wati-widget"]',
//         '[id*="whatsapp"]',
//         '[class*="whatsapp"]',
//         '.whatsapp-container',
//         '.whatsapp-widget',
//       ].forEach(sel => {
//         document.querySelectorAll(sel).forEach(n => n.remove());
//       });


//       const inlineCSS = document.querySelector(
//         'style[data-name="wati-inline-css"]'
//       );
//       if (inlineCSS) inlineCSS.remove();

    
//       delete window.watiChatWidget;
//       delete window.CreateWhatsappChatWidget;

 
//       this.currentScript = null;
//       this.currentWidgetId = null;

 
//     } catch (err) {
//       console.error('[WATI] ❌  Error during cleanup:', err);
//     }
//   }


//   static loadWidget(config) {

//     this.removeCurrentWidget();

//     const script = document.createElement('script');
//     script.src = config.scriptUrl;
//     script.id = config.id;
//     script.async = true;
//     script.onload = () => {
//       if (window.CreateWhatsappChatWidget) {
//         window.CreateWhatsappChatWidget(config.options);
//         this.currentWidgetId = config.id;
//         this.currentScript = script;
        
//       } else {
//         console.error('[WATI] ❌  CreateWhatsappChatWidget missing');
//       }
//     };
//     script.onerror = e =>
//       console.error('[WATI] ❌  Failed to load script:', e);

//     document.head.appendChild(script);
//   }
// }








// MAIN RAZORPAY CONFIG - Payment area disabled
// export const Paymenthandle = (amountValue, orderid) => {
//   return new Promise((resolve, reject) => {
//     const user = getLocalstoreData('userdata')
//     var amount = amountValue * 100
//     const options = {
//       key: process.env.RAZORPAY_KEY,
//       amount: amount,
//       currency: 'INR',
//       name: 'AbleAura',
//       description: `Add Money To Wallet`,
//       image:
//         'https://png.pngtree.com/element_our/png_detail/20181114/transaction-icon-png_239785.jpg',
//       order_id: orderid,
//       handler: function (data) {
//         let finaldata = {
//           ...data,
//           amount: amount,
//         }
//         resolve(finaldata)
//       },
//       prefill: {
//         name: user?.first_name || '',
//         email: user?.email || '',
//         contact: user?.phone || '',
//       },
//       theme: {
//         color: '#000000',
//       },
//     }
//     if (typeof window !== 'undefined' && window.Razorpay) {
//       try {
//         const rzp1 = new window.Razorpay(options)
//         rzp1.open()
//         rzp1.on('payment.failed', function (response) { })
//       } catch (error) {
//         reject(new Error('Payment gateway initialization failed'))
//       }
//     } else {
//       reject(new Error('Payment gateway not available'))
//     }
//   })
// }


// MAIN RAZORPAY CONFIG - Payment area disabled
// const subscription_id = getLocalstoreData('subsid')

// export const subscriptionHandle = (subscriptionid) => {
//   return new Promise((resolve, reject) => {
//     const loadRazorpay = async () => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       document.body.appendChild(script);

//       await new Promise(resolve => {
//         script.onload = resolve;
//       });

//       const user = getLocalstoreData('userdata');

//       const rzp = new window.Razorpay({
//         key: process.env.RAZORPAY_KEY,
//         subscription_id: subscriptionid,
//         currency: 'INR',
//         name: 'Able Aura',
//         description: 'Subscription Payment',
//         image: 'https://able-email-media.s3.amazonaws.com/logo/logo_black.png',
//         handler: function (data) {
//           // Razorpay data processed
//           resolve(data);
//         },

//         prefill: {
//           name: user?.first_name || '',
//           email: user?.email || '',
//           contact: user?.phone || '',
//         }
//       });

//       rzp.open();
//     };

//     loadRazorpay();
//   });
// };


// MAIN RAZORPAY CONFIG - Payment area disabled
// export const Photographypayment = (storedId) => {
//   return new Promise((resolve, reject) => {
//     const loadRazorpay = async () => {
//       if (typeof document === 'undefined' || !document.body) {
//         throw new Error('Document not available');
//       }

//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;

//       await new Promise((resolve, reject) => {
//         script.onload = resolve;
//         script.onerror = () => reject(new Error('Failed to load Razorpay script'));
//         document.body.appendChild(script);
//       });

//       const user = getSessionstoreData('register_details');

//       const rzp = new window.Razorpay({
//         key: process.env.RAZORPAY_KEY,
//         order_id: storedId,
//         currency: 'INR',
//         name: 'Able Aura',
//         description: 'Photography',
//         image: 'https://able-email-media.s3.amazonaws.com/logo/logo_black.png',
//         handler: function (data) {
//           // Razorpay data processed
//           resolve(data);
//         },

//         prefill: {
//           name: user?.parent_name || '',
//           email: user?.parent_email_id || '',
//           contact: user?.parent_contact_number || '',
//         }
//       });

//       try {
//         rzp.open();
//       } catch (error) {
//         reject(new Error('Payment gateway failed to open'));
//       }
//     };

//     loadRazorpay().catch(reject);
//   });
// };


export const errortoast = message => {
  toast(message, {
    autoClose: true,
    containerId: 'errorToast',
    icon: ({ theme, type }) => (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M153.5 144.3C105.8 123.5 67 98.8 48 64c-8.1-14.9-29.2-8.4-28.1 8.7 6.7 105.4 80.6 155.5 133.8 172.9-10.4-12.1-20.9-27.3-25.7-44.3-1.6-5.8 4.1-11.3 9.8-9.8C215.3 212.4 256 260 256 316c0 35.3-14.3 67.3-37.4 90.4 5.6-12.5 9.5-27 9.5-43.4 0-77.9-69.5-116-108.5-193.1-1.9-3.7-6.9-4.2-9.5-.8L66 226.3C53.1 245.5 48 261.2 48 277.3 48 376.6 121.4 448 220.5 448 324.9 448 400 372.9 400 268.5 400 180.4 339.7 116.7 282.3 82.3c-18.9-11-40.6-17.3-63-18.3-16.8-.7-26.2 18.2-14.8 30.6 16.2 18 27.5 39.9 27.5 65.4 0 28.1-13.5 53.1-34.4 69-3.7-34.5-13.1-71.2-44.1-84.7z"/>
      </svg>
    ),
  })
}

export const getFirstErrorKey = (object, keys = []) => {
  const firstErrorKey = Object.keys(object)[0]
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey])
  }
  return [...keys, firstErrorKey].join('.')
}

export const successtoast = message => {
  toast(message, {
    autoClose: true,
    containerId: 'successToast',
    icon: ({ theme, type }) => (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48 0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1 4.4 7.3 6.9 15.8 6.9 24.9 0 21.3-13.9 39.4-33.1 45.6.7 3.3 1.1 6.8 1.1 10.4 0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"/>
      </svg>
    ),
  })
}

export const bytesToSize = bytes => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}

export const ReadMore = ({ children }) => {
  const text = children
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  return (
    <p className="text">
      {text ? (
        <>
          {isReadMore ? text.slice(0, 350) : text}
          {text.length >= 350 && (
            <span role='button' onClick={toggleReadMore} className="read-or-hide">
              {isReadMore ? 'Show More' : ' Show Less'}
            </span>
          )}
        </>
      ) : (
        <>{children}</>
      )}
    </p>
  )
}

export function start_and_end(str) {
  if (str.length > 20) {
    return str.substr(0, 10) + '...' + str.substr(str.length - 10, str.length)
  }
  return str
}

export const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}) => {
  const internal = /^\/(?!\/)/.test(to)
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        role={other.role ? other.role : 'link'}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  } else if (to !== undefined) {
    return (
      <a role="link" href={to} {...other}>
        {children}
      </a>
    )
  } else {
    return <div {...other}>{children}</div>
  }
}
export default Link


// export const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload?.length) {
//     return (
//       <div className='custom-tooltip'>
//         <span>{label}</span>
//         <br></br>
//         {payload.map((ele, index) => (
//           <React.Fragment key={index}>
//             <small className='text-secondary'>
//               {ele.name}, {ele.value}
//             </small>
//             <br></br>
//           </React.Fragment>
//         ))}
//       </div>
//     );
//   }
//   return null;
// };

export const useScrollLock = () => {
  const lockScroll = React.useCallback(() => {
    if (typeof document !== 'undefined' && document.body) {
      document.body.style.overflow = 'hidden'
    }
  }, [])

  const unlockScroll = React.useCallback(() => {
    if (typeof document !== 'undefined' && document.body) {
      document.body.style.overflow = ''
    }
  }, [])

  return {
    lockScroll,
    unlockScroll,
  }
}


export const authNavigate = () => {
  const currentPath = getSessionstoreData('currentpath')
  // Current path processed
  if (getSessionstoreData('referalCode') !== null) {
    var referalCode = {
      referal_code: getSessionstoreData('referalCode'),
    }
    verifyReferal(referalCode)
      .then(response => {
        if (response.data.success) {
          DeleteSessionstore('referalCode')
        } else {
          DeleteSessionstore('referalCode')
        }
      })
      .catch(error => {
        DeleteSessionstore('referalCode')
        // Error handled
      })
    return '/'
  } else if (getSessionstoreData('isFrom') === 'Cart') {
    DeleteSessionstore('isFrom')
    return '/cart'
  } else if (getSessionstoreData('isFrom') === 'servicelist') {
    DeleteSessionstore('isFrom')
    //Sessionstore("isFromservice", true)
    Sessionstore("currentpath", true,);
    return '/AccountConfigure/profile'

  }


  else {
    if (getSessionstoreData('benefitary') !== null) {
      let data = getSessionstoreData('benefitary')
      if (data === 1) {
        sessionStorage.removeItem('benefitary')
        return '/benefitary/upload'
      } else if (data === 2) {
        sessionStorage.removeItem('benefitary')
        return '/endoser/upload'
      } else if (data === 3) {
        sessionStorage.removeItem('benefitary')
        return '/academy'
      }
      else {
        return '/'
      }
    } else {
      return '/'
    }
  }
}

export const getAmountFromStringtoNumber = amountText => {
  return parseFloat(
    parseFloat(amountText)
      .toFixed(2)
      .replace(/(\d)(?=(\d{20})+(?!\d))/g, '$1,')
  )
}

export const InputSelect = props => (
  <components.Input {...props} maxLength={25} />
)

export const isValidFileUploaded = (file, extevalidExtensionsn) => {
  return extevalidExtensionsn.some(format =>
    file.name.toLowerCase().endsWith(format.toLowerCase())
  )
}

